import * as XLSX from 'xlsx';

const isXlsFile = (file) => {
  if (!file) return;
  const { name, title } = file;
  const value = name || title;

  const { format } = file;

  return value.endsWith('.xls') || value.endsWith('.xlsx') || (format && format.toLowerCase().endsWith('excel'));
};

const isPdfFile = (file) => {
  if (!file) return;
  const { name, title } = file;
  const value = name || title;

  const { format } = file;

  return value.endsWith('.pdf') || (format && format.toLowerCase().endsWith('pdf'));
};

const getDocumentIcon = (document) => {
  // A LINK source (external URL) — never a file, whatever its URL ends with.
  if (document && document.type === 'LINK') {
    return 'link';
  }
  if (document && isXlsFile(document)) {
    return 'file-excel';
  } else if (document && isPdfFile(document)) {
    return 'file-pdf-box';
  } else {
    return 'file-text';
  }
};

const getDocumentExcelSheets = (pdfData) => {
  return new Promise((resolve, reject) => {
    const byteNumbers = new Array(pdfData.length);
    for (let i = 0; i < pdfData.length; i++) {
      byteNumbers[i] = pdfData.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetNames = workbook.SheetNames;
      resolve(sheetNames);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsArrayBuffer(blob);
  });
};

const getDocumentExcelSheetsFromUrl = (fileUrl, headers = {}) => {
  return new Promise((resolve, reject) => {
    fetch(fileUrl, { headers })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch the file: ${response.statusText}`);
        }
        return response.arrayBuffer();
      })
      .then((arrayBuffer) => {
        const data = new Uint8Array(arrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetNames = workbook.SheetNames;
        resolve(sheetNames);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDocumentFormat = (documentFormat) => {
  if (isPdfFormat(documentFormat)) return 'pdf';
  if (isExcelFormat(documentFormat)) return 'xls';
  else return documentFormat;
};

const isExcelFormat = (format) => {
  const excelRegex = /(xls|xlsx|ms-excel)/i;
  return excelRegex.test(format);
};

const isPdfFormat = (format) => {
  const pdfRegex = /(pdf|application\/pdf)/i;
  return pdfRegex.test(format);
};

export {
  getDocumentExcelSheets,
  getDocumentExcelSheetsFromUrl,
  getDocumentIcon,
  getDocumentFormat,
  isPdfFile,
  isXlsFile,
};
